import { MaskText, Reveal } from "./Motion";

export const PageHeader = ({ eyebrow, lines, intro }) => (
  <header className="pt-36 md:pt-52 pb-14 md:pb-24">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <Reveal><p className="text-sand-deep text-[11px] uppercase tracking-[0.3em] mb-6">{eyebrow}</p></Reveal>
      <MaskText as="h1" className="font-serif text-5xl sm:text-7xl lg:text-[8rem] leading-[0.86] text-ink tracking-[-0.02em]" lines={lines} />
      {intro && (
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-ink-soft text-base md:text-lg leading-relaxed">{intro}</p>
        </Reveal>
      )}
    </div>
  </header>
);
